import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    container: {
        padding: "10px 0",
        position: "absolute",
        top: 10,
        cursor: "pointer",
        ...(theme.direction === "rtl" ? { left: 0 } : { right: 0 }),
        [theme.breakpoints.down("desktop")]: {
            position: "relative",
            marginBottom: 10,
        },
    },
    disabled: {
        cursor: "auto",
        opacity: 0.4,
    },
    text: {
        textDecoration: "underline",
    },
    loader: {
        position: "absolute",
        top: 5,
        left: "-3rem",
        [theme.breakpoints.down("desktop")]: {
            left: "3rem",
        },
    },
}));

export default useStyles;
